// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2k4kr","additionalInfo":"AgreementModal_additionalInfo__2Dwua"};